// import React, { useState } from "react";
// import { Form, Button, Container} from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";

// const API_URL = process.env.REACT_APP_API_URL;

// function CreateLeadByUploadingCSV() {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [file, setFile] = useState(null);

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!file) {
//       Swal.fire({
//         icon: "error",
//         title: "No CSV File",
//         text: "Please select a CSV file before submitting.",
//       });
//       return;
//     }
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         Swal.fire({
//           icon: "error",
//           title: "Authentication Error",
//           text: "Authentication token not found. Please log in.",
//         });
//         return;
//       }

//       const uploadData = new FormData();
//       uploadData.append("propertyLeadCsv", file); 

//       const response = await fetch(`${API_URL}/property-lead-import`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: uploadData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: errorData.message || "Failed to import Property Lead.",
//         });
//         return;
//       }

//       const result = await response.json();

//       if (result.status == "success") {
        
//         if (result.summary && result.summary.imported === 0) {
//           Swal.fire({
//             icon: "warning",
//             title: "No Data Imported",
//             text: "Sorry, no data was imported. Please check your CSV file or duplicate entry and try again.",
//             confirmButtonText: "OK"
//           });
//         } else {
//           Swal.fire({
//             icon: "success",
//             title: "Success",
//             text: `Successfully imported ${result.summary?.imported || 0} Property Lead!`,
//             confirmButtonText: "OK"
//           });

//           setFile(null);
//           document.querySelector('input[type="file"]').value = "";

//           setTimeout(() => {
//             navigate("/lead-list");
//           }, 2000);
//         }
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: result.message || "Something went wrong!",
//           confirmButtonText: "OK"
//         });
//       }
//     } catch (err) {
//       console.error("Error importing Property Lead:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: err.message || "An unexpected error occurred.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Container className="mt-2">
//       <div className="row">
//         <div className="col-md-12">
//           <div className="card">
//             <div className="card-header">
//               <div className="d-flex align-items-center justify-content-between">
//                 <div className="titlepage">
//                   <h3>Create New Lead By Uploading CSV</h3>
//                 </div>             
//               </div>
//             </div>
//             <div className="card-body">
//               <Form onSubmit={handleSubmit}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Select CSV File</Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept=".csv"
//                     onChange={(e) => {
//                       const selectedFile = e.target.files[0];
//                       if (!selectedFile) return;

//                       const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
//                       if (fileExtension !== "csv") {
//                         Swal.fire({
//                           icon: "error",
//                           title: "Invalid File",
//                           text: "Only CSV files are allowed!",
//                         });
//                         e.target.value = null;
//                         setFile(null);
//                         return;
//                       }
//                       setFile(selectedFile);
//                     }}
//                   />
//                   <Form.Text className="text-muted">
//                     Only CSV files are allowed. Maximum file size: 10MB
//                   </Form.Text>
//                 </Form.Group>

//                 {file && (
//                   <div className="alert alert-info">
//                     Selected file: <strong>{file.name}</strong>
//                   </div>
//                 )}

//                 <div className="submitbutton">
//                   <Button
//                     type="submit"
//                     className="submitbutton_design mt-2"
//                     disabled={loading || !file}
//                     variant="primary"
//                   >
//                     {loading ? (
//                       <>
//                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                         Importing...
//                       </>
//                     ) : (
//                       "Import Projects"
//                     )}
//                   </Button>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Container>
//   );
// }

// export default CreateLeadByUploadingCSV;

import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;

function CreateLeadByUploadingCSV() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      Swal.fire({
        icon: "error",
        title: "No CSV File",
        text: "Please select a CSV file before submitting.",
      });
      return;
    }
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        Swal.fire({
          icon: "error",
          title: "Authentication Error",
          text: "Authentication token not found. Please log in.",
        });
        return;
      }

      const uploadData = new FormData();
      uploadData.append("propertyLeadCsv", file);

      const response = await fetch(`${API_URL}/property-lead-import`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: uploadData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorData.message || "Failed to import Property Lead.",
        });
        return;
      }

      const result = await response.json();

      if (result.status === "success") {
        if (result.summary && result.summary.imported === 0) {
          Swal.fire({
            icon: "warning",
            title: "No Data Imported",
            text: "Sorry, no data was imported. Please check your CSV file or duplicate entry and try again.",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Successfully imported ${result.summary?.imported || 0} Property Lead!`,
            confirmButtonText: "OK",
          });

          setFile(null);
          const input = document.querySelector('input[type="file"]');
          if (input) input.value = "";

          setTimeout(() => {
            navigate("/lead-list");
          }, 2000);
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.message || "Something went wrong!",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error("Error importing Property Lead:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📁
            </div>
            <div style={{ flex: 1 }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Create New Lead By Uploading CSV
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Upload a CSV file to import multiple property leads at once
              </p>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "30px" }}>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3" controlId="formCsvFile">
                      <Form.Label>
                        Select CSV File <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".csv"
                        onChange={(e) => {
                          const selectedFile = e.target.files[0];
                          if (!selectedFile) return;

                          const fileExtension = selectedFile.name
                            .split(".")
                            .pop()
                            .toLowerCase();

                          if (fileExtension !== "csv") {
                            Swal.fire({
                              icon: "error",
                              title: "Invalid File",
                              text: "Only CSV files are allowed!",
                            });
                            e.target.value = null;
                            setFile(null);
                            return;
                          }
                          setFile(selectedFile);
                        }}
                      />
                      <Form.Text className="text-muted">
                        Only CSV files are allowed. Maximum file size: 10MB
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                {file && (
                  <div
                    style={{
                      background: "#eff6ff",
                      border: "1.5px solid #bfdbfe",
                      borderRadius: "10px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "20px",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}>📄</span>
                    <span
                      style={{
                        fontSize: "13.5px",
                        color: "#1e3a5f",
                        fontWeight: "600",
                      }}
                    >
                      Selected file:{" "}
                      <span style={{ color: "#1e5799" }}>{file.name}</span>
                    </span>
                  </div>
                )}

                {/* Submit Button */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingTop: "20px",
                    borderTop: "1.5px dashed #e2e8f0",
                  }}
                >
                  <button
                    type="submit"
                    disabled={loading || !file}
                    style={{
                      padding: "13px 42px",
                      borderRadius: "12px",
                      border: "none",
                      background:
                        loading || !file
                          ? "#cbd5e1"
                          : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontSize: "14.5px",
                      fontWeight: "800",
                      letterSpacing: "0.5px",
                      cursor: loading || !file ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow:
                        loading || !file
                          ? "none"
                          : "0 8px 24px rgba(30, 87, 153, 0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      minWidth: "220px",
                    }}
                  >
                    {loading ? (
                      <>
                        <span
                          style={{
                            width: "16px",
                            height: "16px",
                            border: "2px solid rgba(255,255,255,0.3)",
                            borderTop: "2px solid #ffffff",
                            borderRadius: "50%",
                            display: "inline-block",
                            animation: "spin 0.8s linear infinite",
                          }}
                        />
                        Importing...
                      </>
                    ) : (
                      "Import Leads"
                    )}
                  </button>
                </div>

                {/* Footer Note */}
                <div
                  style={{
                    marginTop: "20px",
                    paddingTop: "20px",
                    borderTop: "1.5px dashed #e2e8f0",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12.5px",
                      color: "#94a3b8",
                      fontWeight: "500",
                    }}
                  >
                    🔒 All fields marked with{" "}
                    <span style={{ color: "#dc2626" }}>*</span> are required
                  </p>
                </div>
              </Form>
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default CreateLeadByUploadingCSV;